export default function requestIdleCallback( callback: () => void, options: IdleRequestOptions = {} ) {
    if ( window.requestIdleCallback ) {
        window.requestIdleCallback( callback, options );
    } else {
        window.setTimeout( callback, 1 );
    }
}
